function SectionTitle(props) {
    return (
        <h2 className="subsection-title">{props.label}</h2>
    );
}

export default SectionTitle;